<template>
    <div class="dashboard-hashrate-tags">
        <UITag v-for="tag in getTags" :key="tag.id" :tag="tag" />
    </div>
</template>

<script>
import UITag from "@/components/ui/tag/tag.vue";

import {VIEWS} from "@/components/ui/tag/tag.vue";

export default {
    name: "DashboardHashrateTags",
    components: {
        UITag,
    },
    props: {
        dashboard: {
            type: Object,
            required: true,
        },
    },
    computed: {
        getTags() {
            const {totalHashrate, unit} = this.dashboard.chart;
            const {rubPaid, rubExpect} = this.dashboard;

            const tags = [
                {
                    id: 0,
                    label: this.$t('workers.hashrate'),
                    value: `${totalHashrate}` + ' ' + `${unit}`,
                    view: VIEWS.purple,
                },
            ];

            if (rubPaid != null) {
                tags.push({
                    id: 1,
                    label: this.$t('dashboard.rubPaid'),
                    value: '≈ ' + new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rubPaid) + ' ₽',
                    view: VIEWS.green,
                });
            }

            if (rubExpect != null) {
                tags.push({
                    id: 2,
                    label: this.$t('dashboard.rubExpect'),
                    value: '≈ ' + new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rubExpect) + ' ₽',
                    view: VIEWS.orange,
                });
            }

            return tags;
        },
    },
};
</script>

<style lang="scss">
.dashboard-hashrate-tags {
    display: flex;
    grid-column-gap: 24px;
}

@media screen and (max-width: 768px) {
    .dashboard-hashrate-tags {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 16px;
    }
}
</style>
